module.exports = __webpack_public_path__ + "static/media/our-service.7816454d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Partner/imgs/our-service.jpg
// module id = 1519
// module chunks = 0